type Props = {
  state?: string | null;
  offeredAt?: string | Date | null;
  daysRemaining?: number | null;
  expiresAt?: string | Date | null;
};

export default function GrantOfferAcceptanceBadge({
  state,
  offeredAt,
  daysRemaining,
  expiresAt,
}: Props) {
  const expired = state === "OFFER_EXPIRED";
  // Expiry is the grant's primary status, so the status chip already conveys it.
  // Keep this component for the supplementary countdown on open offers only.
  if (expired) return null;
  // Non-expiring (and legacy) offers should not display a second status badge.
  if (state !== "OFFERED" || !offeredAt || !expiresAt) {
    return null;
  }

  const remainingDays = daysRemaining ?? 0;

  const label =
    remainingDays === 0
      ? "expires today"
      : `expires in ${remainingDays} day${remainingDays === 1 ? "" : "s"}`;
  const color = "#E85936";
  const backgroundColor = "#EFF8FF";

  return (
    <span
      className="h-5 rounded-sm px-2 text-[10px] font-medium leading-5 whitespace-nowrap"
      style={{ color }}
      title={`Expires ${new Date(expiresAt).toLocaleDateString(undefined, {
        timeZone: "UTC",
      })}`}
    >
      {label}
    </span>
  );
}
